var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVideooff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/ic-videooff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic-videooff",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_video_off"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounds-copy-11",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1901288,63.4526723 C12.4601847,64.1826006 11.2768926,64.1824194 10.547172,63.4522674 C9.81745132,62.7221154 9.81763252,61.5384865 10.5475767,60.8085581 L59.8098712,11.5473277 C60.5398153,10.8173994 61.7231074,10.8175806 62.452828,11.5477326 C63.1825487,12.2778846 63.1823675,13.4615135 62.4524233,14.1914419 L13.1901288,63.4526723 Z",
    id: "Line-2-Copy-2",
    fill: "#707070",
    fillRule: "nonzero",
    transform: "translate(36.500000, 37.500000) rotate(-90.000000) translate(-36.500000, -37.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6616882,20 C51.2296953,20 54.9327967,23.8211828 54.9327967,28.5348506 L54.9327967,28.5348506 L54.9327967,29.0469417 L65.9609413,23.2788051 C66.8153205,22.8324213 67.8329784,22.8755027 68.6490515,23.3926031 C69.4800516,23.9009766 69.9925683,24.8210841 70,25.8179232 L70,25.8179232 L70,54.1820768 C70.0007047,55.1714421 69.5032413,56.0901404 68.68634,56.6080976 C67.8694387,57.1260548 66.8504211,57.1688831 65.9954042,56.7211949 L65.9954042,56.7211949 L63.324,55.324 L51,43 L51,27.1809145 C51,25.4847222 49.7455146,24.0986123 48.1648737,24.0050354 L47.9943136,24 L32,24 L28,20 Z M66.25,27.5 L55,34.0176909 L55,45.9823091 L66.25,52.5 L66.25,27.5 Z",
    id: "Combined-Shape",
    fill: "#707070",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.001,20 L24.001,24 L17.0056864,24 C15.4029329,24 14.09318,25.3276205 14.004758,27.0004109 L14,27.1809145 L14,52.8190855 C14,54.5758561 15.3456917,56 17.0056864,56 L17.0056864,56 L47.9943136,56 C49.6543083,56 51,54.5758561 51,52.8190855 L51,52.8190855 L51,51 L54.4481488,54.4478019 C53.3032991,57.6147477 50.3880223,59.8914663 46.9444404,59.996228 L46.6961512,60 L18.2711085,60 C13.7031014,60 10,56.1788172 10,51.4651494 L10,51.4651494 L10,28.5348506 C10,23.8211828 13.7031014,20 18.2711085,20 L18.2711085,20 L20.001,20 Z",
    id: "Combined-Shape",
    fill: "#707070",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideooff);
export default __webpack_public_path__ + "static/media/ic-videooff.2862398f.svg";
export { ForwardRef as ReactComponent };